// Deep link into an account tab, scoped to a permission set; AccountDetailPage reads these params.
export const setHref = (slug: string, tab: string, key: string) =>
  `/accounts/${encodeURIComponent(slug)}?${new URLSearchParams({ tab, permission_set: key })}`
